import { altDefaultBackgroundCmsMetaKeyOptionValueValueOf } from '../cms/content/ko/CmsContentContract';
import { AltDefaultBackground, type AltDefaultBackgroundInput } from './altDefaultBackground';

const inputs: AltDefaultBackgroundInput[] = [
    { key: 'bg01', label: 'Green' },
    { key: 'bg02', label: 'Orange' },
    { key: 'bg03', label: 'Red' },
    { key: 'bg04', label: 'Purple' },
    { key: 'bg05', label: 'Blue' },
];

class AltDefaultBackgroundsFactory {

    private readonly backgrounds: AltDefaultBackground[];

    private constructor() {
        this.backgrounds = inputs.map((i: AltDefaultBackgroundInput) => new AltDefaultBackground(i));
    }

    public static build(): AltDefaultBackgroundsFactory {
        return new AltDefaultBackgroundsFactory();
    }

    public get(key?: string): AltDefaultBackground[] {
        if (!key) {
            return JSON.parse(JSON.stringify(this.backgrounds));
        }
        return JSON.parse(JSON.stringify(this.backgrounds.filter((i: AltDefaultBackground) => i.key === key)));
    }

    public getWithEmptyOption(label?: string): AltDefaultBackground[] {
        const types: AltDefaultBackground[] = this.get();
        types.unshift(this.getEmpty(label));
        return types;
    }

    public getDefault(): AltDefaultBackground {
        return JSON.parse(JSON.stringify(this.backgrounds[0]));
    }

    public getDefaultKey(): string {
        return this.backgrounds[0].key;
    }

    public getKeyByReferenceId(id: string): string {
        if (!id) {
            return undefined;
        }
        const found: AltDefaultBackground = this.backgrounds.find((i: AltDefaultBackground) => altDefaultBackgroundCmsMetaKeyOptionValueValueOf(id) === i.key);
        return found ? found.key : undefined;
    }

    public getEmpty(label: string = '-- None --'): AltDefaultBackground {
        const empty: AltDefaultBackground = this.getDefault();
        empty.key = 'none';
        empty.label = label;
        return empty;
    }

    public getEmptyKey(): string {
        return this.getEmpty().key;
    }
}

const backgrounds = AltDefaultBackgroundsFactory.build();

export { backgrounds as AltDefaultBackgrounds };